import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "table-border-right" }
const _hoisted_6 = { class: "table-border-right" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _cache[3] || (_cache[3] = _createElementVNode("td", { class: "table-border-right" }, [
            _createElementVNode("strong", null, "Meal Plan")
          ], -1)),
          _cache[4] || (_cache[4] = _createElementVNode("td", null, [
            _createElementVNode("strong", null, "Cost per meal")
          ], -1)),
          _cache[5] || (_cache[5] = _createElementVNode("td", null, [
            _createElementVNode("strong", null, [
              _createTextVNode("Ratty ratio"),
              _createElementVNode("sup", null, "*")
            ])
          ], -1)),
          _cache[6] || (_cache[6] = _createElementVNode("td", { class: "table-border-right" }, [
            _createElementVNode("strong", null, "Meals per week")
          ], -1)),
          _cache[7] || (_cache[7] = _createElementVNode("td", null, [
            _createElementVNode("strong", null, "Meal Credits (including guest)")
          ], -1)),
          (_ctx.ignoreFlex)
            ? (_openBlock(), _createElementBlock("td", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("strong", null, "Cost minus flex points", -1)
              ]))]))
            : _createCommentVNode("", true),
          (!_ctx.ignoreFlex)
            ? (_openBlock(), _createElementBlock("td", _hoisted_3, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("strong", null, "Flex Points", -1)
              ]))]))
            : _createCommentVNode("", true),
          (!_ctx.ignoreFlex)
            ? (_openBlock(), _createElementBlock("td", _hoisted_4, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("strong", null, "Semester Cost", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plans, (plan) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: plan.name
          }, [
            _createElementVNode("td", _hoisted_5, [
              _createElementVNode("strong", null, _toDisplayString(plan.name), 1)
            ]),
            _createElementVNode("td", null, "$" + _toDisplayString(plan.mealCost), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.rattyProp(plan) === -1 ? '∞' : _ctx.round(_ctx.rattyProp(plan), 0)) + "%", 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.round(_ctx.mealsPerDay(plan) * 7, 1)), 1),
            _createElementVNode("td", null, _toDisplayString(plan.creds + plan.guest), 1),
            (_ctx.ignoreFlex)
              ? (_openBlock(), _createElementBlock("td", _hoisted_7, "$" + _toDisplayString(plan.cost - plan.flex), 1))
              : _createCommentVNode("", true),
            (!_ctx.ignoreFlex)
              ? (_openBlock(), _createElementBlock("td", _hoisted_8, "$" + _toDisplayString(plan.flex), 1))
              : _createCommentVNode("", true),
            (!_ctx.ignoreFlex)
              ? (_openBlock(), _createElementBlock("td", _hoisted_9, "$" + _toDisplayString(plan.cost), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("p", null, [
      _createElementVNode("sup", null, "*"),
      _createTextVNode("Percent of meals at ratty/vdub required to break even and have being on meal plan be worth it")
    ], -1))
  ]))
}